module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/about-wynona-299.2ee8d2607bb27758.jpg"+" 299w",
        images: [{path: "https://static.sniffspot.com/packs/img/about-wynona-299.2ee8d2607bb27758.jpg",width: 299,height: 208}],
        src: "https://static.sniffspot.com/packs/img/about-wynona-299.2ee8d2607bb27758.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/about-wynona-299.2ee8d2607bb27758.jpg"},
        
        width: 299,
        height: 208
      }